export default class NavigationController {
    constructor($scope, $location, userService, authenticationService, $routeParams) {
        this.$scope = $scope;
        this.$location = $location;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.$routeParams = $routeParams;

        this.printAsPDF = function() {
            window.print();
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/components/navigation/navigation.controller.js